"use client";
import { Community } from "@prisma/client";
import { useState } from "react";
import EventProposeModal from "~/components/v3/modals/ProposeEventModal";
import { Button } from "~/components/v3/themed/Button";

type Props = {
    community: Pick<
        Community,
        | "id"
        | "name"
        | "slug"
        | "image"
        | "defaultTags"
        | "forceUseOfTemplatedEvent"
        | "hostRequiredData"
    >;
};

const EventProposeModalWrapperPage = ({ community }: Props) => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <div className="mt-16">
            <EventProposeModal
                community={community}
                open={isOpen}
                setOpen={setIsOpen}
            />

            <Button
                onClick={() => {
                    setIsOpen(true);
                }}
            >
                Propose Event?
            </Button>
        </div>
    );
};
export default EventProposeModalWrapperPage;
